<app-nav></app-nav>
<app-home></app-home>
<app-team></app-team>
<app-about></app-about>
<app-services-carousel></app-services-carousel>
<app-testimonials></app-testimonials>
<app-contact-us></app-contact-us>
<app-footer></app-footer>
